// extracted by mini-css-extract-plugin
export default {"topicTitle":"aqcb4JUd","scrollButton":"pMtU6_F8","scrollButtonText":"t4PAEQ45"};